import React from 'react';

import LearousCarousel from 'react-material-ui-carousel'

const Carousel = (props) => {
  const {children, ...restProps} = props
  return (
    <LearousCarousel {...restProps}>
      {children}
    </LearousCarousel>
  )
}

export default Carousel